import { Component, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { addDays } from 'date-fns';
import { ManagerSignComponent } from '../manager-sign/manager-sign.component';
import { AppService } from 'src/app/services/app/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { UserConflictsComponent } from '../user-conflicts/user-conflicts.component';
import { ConflictsComponent } from '../../conflicts/conflicts.component';
import { GlobalService } from 'src/app/services/global/global.service';
import { E } from '@angular/cdk/keycodes';
import { ConfirmationModalComponent } from 'src/app/pages/dialog-modal/confirmation-modal/confirmation-modal.component';
import { StarRatingComponent } from 'src/app/pages/employees/star-rating/star-rating.component';

@Component({
  selector: 'app-time-sheet-details',
  templateUrl: './time-sheet-details.component.html',
  styleUrls: ['./time-sheet-details.component.scss']
})
export class TimeSheetDetailsComponent {

  // displayedColumns: string[] = ['check-box', 'date', 'category', 'location', 'start', 'end', 'total-hours', 'break', 'daily-total', 'employe-notes', 'manager-sign-off', 'favorite'];
  displayedColumns: string[] = ['date', 'category', 'start', 'end', 'total-hours', 'break', 'daily-total', 'employe-notes', 'manager-sign-off', 'favorite'];
  public dataSource = new MatTableDataSource();
  public range!: FormGroup;
  isSpinnerLoading = false;
  public timeSheetArr: any[] = [];
  public timeSheetInfo: any;
  public imageUrl: string = GlobalService.imageURL;
  public googleMapLink = "https://www.google.com/maps?q=@";
  public employeeStatus: any[] = [
    { name: "Mark as absent", value: "0" },
    { name: "Mark as early", value: "1" },
    { name: "Mark as late", value: "2" },
    { name: "Mark as sick", value: "3" },
  ]

  constructor(private commonService: CommonService, private dialog: MatDialog, private timeClockService: TimeClockService,
    private fb: FormBuilder, private datePipe: DatePipe, @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<TimeSheetDetailsComponent>, private appService: AppService, private spinner: NgxSpinnerService,
    private recruiterService: RecruiterService
  ) { }

  ngOnInit(): void {
    this.commonService.setTitle("Time Clock");
    // this.loadData();
    // this.getList()
    this.range = this.fb.group({
      start: "",
      end: ""
    })
    this.range.get('end')?.setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
    this.range.get('start')?.setValue(this.datePipe.transform(new Date(new Date().setDate(new Date().getDate() - 14)), 'yyyy-MM-dd'));

    this.getList();
  }
  onCloseCal() {
    this.getList()
  }
  getList() {
    let obj = {
      "st_dt": this.datePipe.transform(this.range.get("start")?.value, 'yyyy-MM-dd'),
      "ed_dt": this.datePipe.transform(this.range.get("end")?.value, 'yyyy-MM-dd'),
      "em_i": this.dialogData.em_i || this.dialogData.employee_id,
      tc_id: this.dialogData.params.id,
      "type": this.dialogData.params.type,
    }
    this.isSpinnerLoading = true;
    this.timeClockService.getEmpTimesheet(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.timeSheetArr = []
          success.msg.forEach(week => week.arr.forEach(day => day.wo_data.push(this.createNullData())));
          this.timeSheetArr = success.msg;
          this.timeSheetInfo = success.info;
        }
        this.isSpinnerLoading = false;

      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      }
    })
  }

  createNullData() {
    return {
      "id": null,
      "cl_in_img": null,
      "cl_out_img": null,
      "ma_sign": null,
      "c_ed_ti": null,
      "c_st_ti": null,
      "c_lat": null,
      "br_ti": null,
      "new_wages": null,
      "wages": null,
      "c_long": null,
      "em_i": null,
      "date": null,
      "ov_ti_h": null,
      "br_tii": null,
      "br_tio": null,
      "st_ti": null,
      "ed_ti": null,
      "wo_ti": null,
      "clock_id": null,
      "add": null,
      "city": null,
      "country": null,
      "j_n": null,
      "shift": null,
      "j_c": null,
      "j_sc": null,
      "lat": null,
      "long": null,
      "email": null,
      "first_name": null,
      "last_name": null,
      "profile_picture": null,
      "app": null,
      "time_diff": null,
      "cu_name": null,
      "cu_pic": null,
      "updu_name": null,
      "updu_pic": null,
      "la_upd": null
    };
  }

  onChangeTime(startTime: any, endTime: any, date: any, employeeId: any, clockId: any, jobId: any, br_tii: any, br_tio: any, isChangeBreakTime: boolean) {


    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;


    const isStartTimeValid = timeRegex.test(startTime);
    const isEndTimeValid = timeRegex.test(endTime);
    const isStartBreakTimeValid = timeRegex.test(br_tii);
    const isEndBreakTimeValid = timeRegex.test(br_tio);

    if (!isStartTimeValid || !isEndTimeValid || !isStartBreakTimeValid || !isEndBreakTimeValid) {
      this.appService.showToastMessage("error", "Enter valid time format. ");
      return
    }

    let obj = {
      "j_id": jobId,
      "clock_id": clockId,
      "st_ti": startTime,
      "ed_ti": endTime,
      "em_i": employeeId,
      "date": date,
      "br_tii": br_tii,
      "br_tio": br_tio,
    };

    this.spinner.show();
    if (isChangeBreakTime) {
      this.recruiterService.editBreakTime(obj).subscribe({
        next: (data: any) => {
          this.spinner.hide();
          if (data["status"] == 200) {
            this.appService.showToastMessage("success", data["msg"]);
            this.dialogRef.close({ add_quick_task: true });
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    } else {
      this.timeClockService.changeTime(obj).subscribe({
        next: (success: any) => {
          this.spinner.hide();
          if (success.status == 200) {
            this.appService.showToastMessage("success", success["msg"]);
            this.getList()
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        }
      })
    }
  }

  onManagerSign(element) {
    const data = {
      j_id: element.id,
      woti_id: element.clock_id,
    };
    const dialogRef = this.dialog.open(ManagerSignComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      minWidth: '340px',
      height: 'auto',
      minHeight: '300px',
      autoFocus: false,
      data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList()
      }
    });
  }

  onValueChange(selectedValue: string): void {

    if (selectedValue == 'timesheet') {
      let obj = {
        // "st_dt": "2023-08-01",
        // "ed_dt": "2023-08-14",
        "st_dt": this.datePipe.transform(this.range.get("start")?.value, 'yyyy-MM-dd'),
        "ed_dt": this.datePipe.transform(this.range.get("end")?.value, 'yyyy-MM-dd'),
        "tc_id": this.dialogData.params.id,
        "type": this.dialogData.params.type,
      };

      this.spinner.show();
      this.recruiterService.timesheetReport(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.spinner.hide();
            this.appService.downloadFile(success.msg, 'timesheet');
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          //   this.isSpinnerLoading = false
          this.commonService.handleError(error);
        },
      });
    } else if (selectedValue == 'shift_report') {
      let obj = {
        // "st_dt": "2023-08-01",
        // "ed_dt": "2023-08-14",
        "st_dt": this.datePipe.transform(this.range.get("start")?.value, 'yyyy-MM-dd'),
        "ed_dt": this.datePipe.transform(this.range.get("end")?.value, 'yyyy-MM-dd'),
      };
      this.spinner.show();
      this.recruiterService.shiftReport(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.spinner.hide();
            this.appService.downloadFile(success.sheet, 'shiftreport');
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          //   this.isSpinnerLoading = false;
          this.commonService.handleError(error);
        },
      });
    }
  }

  onOpenConflicts() {
    let objData = {
      "st_dt": this.datePipe.transform(this.range.get("start")?.value, 'yyyy-MM-dd'),
      "ed_dt": this.datePipe.transform(this.range.get("end")?.value, 'yyyy-MM-dd'),
      "em_i": this.dialogData.em_i || this.dialogData.employee_id,
      tc_id: this.dialogData.params.id,
      "type": this.dialogData.params.type,
    }
    const dialogRef = this.dialog.open(UserConflictsComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      width: '90%',
      height: '98%',
      maxWidth: '600px',
      autoFocus: false,
      data: objData,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  checkUrl(url: any) {

    let newUrl;
    if (url?.includes("https")) {
      newUrl = url;
    } else {
      newUrl = GlobalService.imageURL + url;
    }
    return newUrl;
  }

  onImgError(event: Event): void {

    const target = event.target as HTMLImageElement;
    if (target) {
      target.src = 'assets/images/icons/user_icon.svg'
    }
  }

  onChangeEmpSt(item, value, date) {
    let dataObj = {
      "j_id": item.id,
      "em_i": item.em_i,
      "em_st": value
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { dataObj, content_type: "employee_status" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          // this.getEmpData(date);
          this.getList()
        }
      }
      if (result == undefined) {
      }
    });
  }

  onAddComments(item) {
    const dialogRef = this.dialog.open(StarRatingComponent, {
      width: '90%', maxWidth: "400px", height: "95%", maxHeight: '470px',
      data: { id: item.id, em_i: item.em_i }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  confirmationAlert(dataObj: any, type: string, value: string) {
  
      let data = {
        j_id: dataObj.id,
        clock_id: dataObj.clock_id,
        em_i: dataObj.em_i,
        app: "",
        ov_ti_app: "",
      };
      if (type == "overtime") {
        data["ov_ti_app"] = value;
      } else {
        data["app"] = value;
      }
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: {
          content_type: "accept_reject",
          dataObj: data,
          item_type: "time_clock_status",
          data_type: "change"
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm_yes == true) {
          this.getList();
        }
      });
    }
}
